import React, {useMemo} from 'react';
import styled from 'styled-components';
import UmbracoForm from '~Umbraco/Components/UmbracoForm/UmbracoForm';
import Typography from 'design-system/src/Components/Typography/Typography';
import Metrics from 'design-system/src/Theme/Metrics';
import {Form} from '@src/Api/Umbraco/interface/UmbracoTypes';
import {completeInitialValuesWithDefaults} from '@src/utils/umb-forms/completeInitialValuesWithDefaults.util';
import {
  withConsentFields,
  withConsentInitialValues,
} from '@src/App/components/Consent/consentForm.utils';

const Container = styled.div.withConfig({
  shouldForwardProp: prop => prop !== 'isMobile',
})<{isMobile: boolean}>`
  width: 100%;
  max-width: 418px;
  padding: ${({isMobile}) => (isMobile ? '0 16px' : '0')};
`;

interface SignUpFormContentProps {
  isMobile: boolean;
  t: (key: string) => string;
  filteredForm: Form;
  initialValues: any;
  onSubmit: (formData: any) => Promise<boolean>;
}

const SignUpFormContent: React.FC<SignUpFormContentProps> = ({
  isMobile,
  t,
  filteredForm,
  initialValues,
  onSubmit,
}) => {
  const formWithConsent = useMemo(
    () => withConsentFields(filteredForm),
    [filteredForm],
  );
  const safeInitialValues = useMemo(
    () =>
      completeInitialValuesWithDefaults(
        formWithConsent,
        withConsentInitialValues(initialValues),
      ),
    [formWithConsent, initialValues],
  );

  const handleSubmit = async (formData: any) => {
    // account_info_submitted is no longer emitted here (it was anonymous — fired
    // before the account/user_id existed). It is now emitted from LayoutProvider's
    // identify effect, once the real user_id is set. See signupPending.
    return onSubmit(formData);
  };

  return (
    <Container isMobile={isMobile}>
      <UmbracoForm
        form={formWithConsent}
        submitLabel={t('Register') + ''}
        autoValidate={false}
        initialValue={safeInitialValues}
        overrideSubmit={handleSubmit}
        renderPageHeader={() => (
          <Typography
            variant={isMobile ? 'body2' : 'formTitle'}
            style={{
              marginBottom: Metrics.verticalScale(12),
              textAlign: 'center',
            }}>
            {t('Sign up')}
          </Typography>
        )}
      />
    </Container>
  );
};

export default SignUpFormContent;
